module.exports = __webpack_public_path__ + "img/Companyshareholdingstructure.880bc2c4.jpg";